import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const MPAmazonIcon = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon viewBox="0 0 132.51 106.01" {...props}>
      <path
        id="path8"
        fill={themeColor === 'light' ? '#221f1f' : '#f90'}
        d="m82.21,64.27c-7.7,5.68-18.86,8.7-28.47,8.7-13.47,0-25.6-4.98-34.78-13.27-.72-.65-.07-1.54.79-1.03,9.9,5.76,22.15,9.23,34.8,9.23,8.53,0,17.92-1.77,26.54-5.43,1.3-.55,2.39.85,1.12,1.8"
      />
      <path
        id="path10"
        fill={themeColor === 'light' ? '#221f1f' : '#f90'}
        d="m85.41,60.6c-.98-1.26-6.51-.59-8.99-.3-.76.09-.87-.57-.19-1.04,4.4-3.1,11.62-2.2,12.46-1.17.84,1.04-.22,8.28-4.35,11.74-.63.53-1.24.25-.96-.46.93-2.32,3.01-7.52,2.02-8.78"
      />
      <path
        id="path12"
        fill={themeColor === 'light' ? '#f90' : '#fff'}
        d="m76.59,37.4v-3.01c0-.46.35-.76.76-.76h13.48c.43,0,.78.31.78.76v2.58c0,.43-.37,1-1.02,1.89l-6.99,9.97c2.6-.06,5.34.32,7.69,1.65.53.3.67.74.72,1.17v3.21c0,.44-.48.95-.99.69-4.15-2.17-9.66-2.41-14.24.02-.47.25-.96-.25-.96-.69v-3.05c0-.49,0-1.33.5-2.07l8.09-11.61h-7.04c-.43,0-.78-.31-.78-.76"
      />
      <path
        id="path14"
        fill={themeColor === 'light' ? '#f90' : '#fff'}
        d="m27.42,56.19h-4.1c-.39-.03-.7-.32-.73-.7v-21.05c0-.42.35-.76.79-.76h3.82c.4.02.72.32.74.7v2.75h.07c1-2.66,2.87-3.9,5.4-3.9s4.17,1.24,5.32,3.9c.99-2.66,3.25-3.9,5.66-3.9,1.72,0,3.6.71,4.75,2.3,1.3,1.77,1.03,4.34,1.03,6.6v13.28c0,.42-.36.76-.8.76h-4.1c-.41-.03-.74-.36-.74-.76v-11.16c0-.89.08-3.1-.12-3.95-.31-1.41-1.22-1.81-2.41-1.81-.99,0-2.03.66-2.45,1.72-.42,1.06-.38,2.84-.38,4.03v11.16c0,.42-.35.76-.79.76h-4.1c-.42-.03-.74-.36-.74-.76v-11.16c0-2.35.38-5.8-2.53-5.8s-2.83,3.37-2.83,5.8v11.16c0,.42-.35.76-.79.76"
      />
      <path
        id="path16"
        fill={themeColor === 'light' ? '#f90' : '#fff'}
        d="m103.22,33.24c6.09,0,9.38,5.23,9.38,11.87s-3.64,11.51-9.38,11.51-9.23-5.23-9.23-11.74,3.29-11.65,9.23-11.65m.03,4.3c-3.02,0-3.21,4.12-3.21,6.69s-.04,8.06,3.18,8.06,3.33-4.43,3.33-7.13c0-1.78-.07-3.9-.61-5.58-.46-1.47-1.38-2.04-2.68-2.04"
      />
      <path
        id="path18"
        fill={themeColor === 'light' ? '#f90' : '#fff'}
        d="m120.49,56.19h-4.08c-.41-.03-.74-.36-.74-.76v-21.05c.03-.39.37-.69.78-.69h3.8c.36.02.65.26.73.59v3.22h.07c1.15-2.88,2.76-4.25,5.59-4.25,1.84,0,3.63.66,4.79,2.48,1.07,1.68,1.07,4.52,1.07,6.55v13.25c-.05.37-.39.66-.79.66h-4.11c-.37-.03-.69-.31-.73-.66v-11.43c0-2.3.27-5.67-2.57-5.67-1,0-1.92.67-2.37,1.68-.58,1.29-.65,2.57-.65,3.99v11.33c0,.42-.36.76-.8.76"
      />
      <g id="use28">
        <path
          id="path30"
          fill={themeColor === 'light' ? '#f90' : '#fff'}
          d="m65.85,46.13v-.89c-2.96,0-6.1.63-6.1,4.13,0,1.77.92,2.97,2.49,2.97,1.15,0,2.19-.71,2.84-1.86.81-1.42.77-2.75.77-4.35m4.14,10c-.27.24-.66.26-.97.1-1.36-1.13-1.6-1.66-2.35-2.73-2.25,2.3-3.84,2.98-6.76,2.98-3.45,0-6.14-2.13-6.14-6.39,0-3.33,1.81-5.6,4.37-6.7,2.23-.98,5.34-1.15,7.71-1.42v-.53c0-.97.07-2.13-.5-2.97-.5-.76-1.46-1.07-2.3-1.07-1.56,0-2.96.8-3.3,2.46-.07.37-.34.73-.71.75l-3.98-.43c-.33-.07-.7-.35-.61-.86.92-4.82,5.27-6.28,9.17-6.28,2,0,4.6.53,6.18,2.04,2,1.86,1.81,4.35,1.81,7.05v6.39c0,1.92.8,2.76,1.55,3.8.27.37.32.81-.01,1.09-.84.7-2.32,2-3.14,2.72h-.01"
        />
      </g>
      <path
        id="path30-2"
        fill={themeColor === 'light' ? '#f90' : '#fff'}
        d="m12.08,46.13v-.89c-2.96,0-6.1.63-6.1,4.13,0,1.77.92,2.97,2.49,2.97,1.15,0,2.19-.71,2.84-1.86.81-1.42.77-2.75.77-4.35m4.14,10c-.27.24-.66.26-.97.1-1.36-1.13-1.6-1.66-2.35-2.73-2.25,2.3-3.84,2.98-6.76,2.98C2.69,56.47,0,54.35,0,50.08,0,46.75,1.81,44.49,4.37,43.38c2.23-.98,5.34-1.15,7.71-1.42v-.53c0-.97.07-2.13-.5-2.97-.5-.76-1.46-1.07-2.3-1.07-1.56,0-2.96.8-3.3,2.46-.07.37-.34.73-.71.75l-3.98-.43c-.33-.07-.7-.35-.61-.86.92-4.82,5.27-6.28,9.17-6.28,2,0,4.6.53,6.18,2.04,2,1.86,1.81,4.35,1.81,7.05v6.39c0,1.92.8,2.76,1.55,3.8.27.37.32.81-.01 1.09-.84.7-2.32,2-3.14,2.72h-.01"
      />
    </SvgIcon>
  );
};

export default MPAmazonIcon;
